module.exports = __webpack_public_path__ + "img/gameCenter.8297c1d2.png";